// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"308":"88d85a24","388":"cc0ed7ce","453":"6869a7fc","730":"9b32511d"}[chunkId] + ".chunk.js";
};